<template>
  <div>
    <top-bar voltar="admin/produtos" fullscreen="true"/>
    <div class="w3-main w3-small" style="margin-top:50px;">
      <form @submit.prevent="cadastrar">
        <div class="w3-container">
          <header style="padding:22px 0">
            <button class="w3-button w3-round primary w3-right" type="submit" style="margin-left: 12px; width: 150px"><i
              class="fa fa-check"></i> <b>{{editar ? 'Salvar' : 'Cadastrar'}}</b>
            </button>
            &nbsp;
          </header>
          <div class="w3-bar w3-white" style="display: none">
            <a href="javascript:" @click="menuselected = 1" class="w3-bar-item w3-button" :class="{'primary' : menuselected === 1}"><i class="fa fa-edit"></i> Básico</a>
            <!--<a href="javascript:" @click="menuselected = 2" class="w3-bar-item w3-button" :class="{'primary' : menuselected === 2}"><i class="fa fa-cog"></i> Avançado</a>-->
          </div>

          <div class="w3-responsive w3-card w3-white w3-padding-16" style="margin-top: 12px" v-show="menuselected === 1">
            <div class="w3-row">
              <div class="w3-col l7">
                <div class="w3-row-padding">
                  <div class="w3-col l12 w3-margin-top">
                    <label for="nome_produto"><b>Nome do Produto</b></label>
                    <input type="text" class="w3-input w3-border" placeholder="Nome Produto" id="nome_produto" v-model="dados.nome_produto"
                           name="nome_produto" required>
                  </div>
                  <div class="w3-col l4 w3-margin-top">
                    <label for="referencia"><b>Referência</b></label>
                    <input type="text" class="w3-input w3-border" placeholder="Ref do Produto"
                           id="referencia" name="referencia" v-model="dados.ref_produto" :disabled="!editar" :required="editar">
                  </div>
                  <div class="w3-col l4 w3-margin-top">
                    <label for="id_categoria"><b>Categoria</b></label>
                    <select class="w3-select w3-white w3-border" id="id_categoria" name="id_categoria" v-model="dados.id_categoria" required>
                      <option v-for="c in categorias" :value="c.id_categoria">{{c.nome_categoria}}</option>
                    </select>
                  </div>
                  <div class="w3-col l4 w3-margin-top">
                    <label for="disponibilidade"><b>Status</b></label>
                    <select class="w3-select w3-white w3-border" id="disponibilidade" name="ingrediente" v-model="dados.fg_ativo" required>
                      <option value="1">Disponível</option>
                      <option value="2">Indisponível</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="w3-col l5 w3-margin-top" style="padding: 0 16px">
                <label for="urlImagem"><b>Imagem do Produto</b></label>
                <input type="text" placeholder="Url da Imagem do produto" class="w3-input w3-border" id="urlImagem" name="urlImagem" v-model="dados.url_imagem"/>
                <div class="w3-padding w3-border" style="height: 250px">
                  <img class="w3-image" :src="dados.url_imagem" style="height: 100%; width: auto; display: block; margin: auto"/>
                </div>
              </div>
            </div>
            <br>
          </div>
          <hr>
          <div v-show="editar">
            <div class="w3-margin-bottom">
              <h6><b>Tabela de Preços</b></h6>
            </div>
            <div class="w3-card w3-white">
              <div class="w3-row-padding">
                <div class="w3-col m2 w3-margin-top">
                  <label for="tabela"><b>Informe a tabela</b></label>
                  <select id="tabela" class="w3-select w3-white w3-border" v-model="tabelaSelect">
                    <option :value="t" v-for="t in tabelas">{{t.nome_tabela}}</option>
                  </select>
                </div>
                <div class="w3-col m2 w3-margin-top">
                  <label for="nome_tabela"><b>Nome da Tabela</b></label>
                  <input id="nome_tabela" placeholder="Nome tabela" class="w3-input w3-border" v-model="tabelaNomeSelect" :disabled="tabelaSelect.outros === '0'"/>
                </div>
                <div class="w3-col m2 w3-margin-top">
                  <label for="codigoTabela"><b>Código</b></label>
                  <input id="codigoTabela" placeholder="Código de Busca" class="w3-input w3-border" v-model="tabelaCodigoSelect"/>
                </div>
                <div class="w3-col m2 w3-margin-top">
                  <label for="valor"><b>Valor</b></label>
                  <money id="valor" class="w3-input w3-border" v-model="valorOriginal" v-bind="money"/>
                </div>
                <div class="w3-col m2 w3-margin-top">
                  <label for="precosValor"><b>Valor Calculado</b></label>
                  <money id="precosValor" class="w3-input w3-border w3-light-gray" v-model="tabelaValor" v-bind="money"/>
                </div>
                <div class="w3-col m2 w3-margin-top">
                  <label>&nbsp;</label>
                  <button class="w3-button w3-black w3-dark-gray w3-block" type="button" @click="addTabela" :disabled="tabelaSelect.outros === '1' && tabelaNomeSelect.trim() === ''">
                    <b>INSERIR</b>
                  </button>
                </div>
              </div>
              <div class="w3-margin-top w3-padding">
                <div class="w3-responsive" style="min-height: 150px">
                  <table class="w3-table w3-bordered w3-centered" id="tablePreco" style="min-width: 750px">
                    <thead>
                    <tr class="primary">
                      <th style="min-width: 150px">Tabela</th>
                      <th style="min-width: 150px">Referência</th>
                      <th style="min-width: 150px">Nome</th>
                      <th style="min-width: 150px">Valor</th>
                      <th style="min-width: 150px">Status</th>
                      <th style="min-width: 150px">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="t in dados.tabelas">
                      <td>
                        <select title="Tabelas" class="w3-select w3-white w3-border" :class="{'w3-light-gray':tabelaEdit !== t.id_tabela_preco}" v-model="t.id_tabela" :disabled="tabelaEdit !== t.id_tabela_preco">
                          <option :value="tab.id_tabela" v-for="tab in tabelas">{{tab.nome_tabela}}</option>
                        </select>
                      </td>
                      <td>
                        <input title="Referência" class="w3-input w3-border" v-model="t.ref_produto" :disabled="tabelaEdit !== t.id_tabela_preco"/>
                      </td>
                      <td>
                        <input title="Tabela" class="w3-input w3-border" v-model="t.nome_tabela" :disabled="tabelaEdit !== t.id_tabela_preco"/>
                      </td>
                      <td>
                        <money class="w3-input w3-border" v-model="t.valor" v-bind="money" :disabled="tabelaEdit !== t.id_tabela_preco"/>
                      </td>
                      <td>
                        <select title="disponibilidade" class="w3-select w3-border w3-white" v-model="t.fg_ativo" :class="{'w3-light-gray':tabelaEdit !== t.id_tabela_preco}" :disabled="tabelaEdit !== t.id_tabela_preco">
                          <option value="1">Disponível</option>
                          <option value="2">Indisponível</option>
                        </select>
                      </td>
                      <td>
                        <select title="unidade" class="w3-select w3-border w3-white" v-model="t.id_medida" :class="{'w3-light-gray':tabelaEdit !== t.id_tabela_preco}" :disabled="tabelaEdit !== t.id_tabela_preco">
                          <option value="1">Unidade</option>
                          <option value="2">Kilo</option>
                        </select>
                      </td>
                      <td>
                        <span v-show="tabelaEdit !== t.id_tabela_preco">
                          <button type="button" class="w3-button w3-dark-gray w3-round" @click="editarTabela(t)"><i class="fa fa-edit"></i><br/><span class="w3-tiny"><b>Alterar</b></span></button>
                          <button type="button" class="w3-button primary w3-round" @click="removeTabela(t)"><i class="fa fa-trash-o"></i><br/><span class="w3-tiny"><b>Deletar</b></span></button>
                        </span>
                            <span v-show="tabelaEdit === t.id_tabela_preco">
                          <button type="button" class="w3-button w3-border w3-round" @click="tabelaEdit = false"><i class="fa fa-times"></i><br/><span class="w3-tiny"><b>Cancelar</b></span></button>
                          <button type="button" class="w3-button w3-dark-gray w3-round" @click="tabelaEdit = false"><i class="fa fa-check"></i><br/><span class="w3-tiny"><b>Concluir</b></span></button>
                        </span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <hr>
            <div>
              <h6><b><i class="fa fa-exclamation-triangle"></i> Danger Zone</b></h6>
            </div>
            <br>
            <div class="w3-responsive w3-card w3-white w3-border w3-margin-bottom" style="min-height: 70px">
              <button type="button" class="w3-button w3-border primary w3-margin" @click="deletar">
                <i class="fa fa-trash-o"></i>
                <b>Deletar este Produto</b>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"
  import {Money} from 'v-money'

  export default {
    components: {TopBar, MenuDash, Money},
    data() {
      return {
        menuselected: 1,
        editar: false,
        token: localStorage.getItem('key'),
        categorias: {},
        tabelas: {},

        tabelaSelect: {},
        tabelaNomeSelect: '',
        tabelaCodigoSelect: '',
        tabelaUnidadeSelect: 1,
        valorOriginal: 0,
        tabelaValor: 0,
        tabelaEdit: false,
        aceitarDivisao: '0',

        dados: {
          id_produto: '',
          id_categoria: 1,
          ref_produto: '',
          nome_produto: '',
          gerar_pedido: 0,
          ingrediente: 0,
          produtos:'',
          adicionais:'',
          tabelas:'',
          url_imagem:'',
          divisaoProduto: 2,
          tabelaDivisao: 2,
          fg_ativo: 1
        },

        money: {decimal: '.', thousands: '', prefix: 'R$ ', suffix: '', precision: 2, masked: false}
      }
    },

    methods: {
      buscarCategorias() {
        this.$http.get(base_url + 'categorias/' + localStorage.getItem('key'))
          .then(response => {
            this.categorias = response.data;

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      buscarTabelas() {
        this.$http.get(base_url + 'tabelas/' + localStorage.getItem('key'))
          .then(response => {
            this.tabelas = response.data;
            this.tabelaSelect = this.tabelas[0];
            closeLoading();

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      cadastrar() {
        let url = base_url + "produto/";
        if (this.editar) {
          url = base_url + 'produto/editar/';

          if(this.tabelaEdit) {
           openModalMsg("Atenção","Confirme ou cancele a edição da tabela de preços!");
           return;
          }
        }

        openLoading("Editando produto");
        this.$http.post(url + this.token, this.dados, {emulateJSON: true})
          .then(res => {
            if (!this.editar) {
              this.$router.push("/admin/produtos/editar/" + res.data);
              this.getProduto(res.data);

            } else {
              openModalMsg("Sucesso!","Produto editado com sucesso.");
              this.getProduto(this.$route.params.id);
            }
            closeLoading();
            console.log(res);

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      getProduto(id) {

        openLoading("Buscando os dados");
        this.editar = true;

        this.$http.get(base_url + 'produto/id/' + this.token + '?produtos=' + id)
          .then(response => {
            let produto = response.data.produto;
            let itens = response.data.itens;
            let adicionais = response.data.adicionais;
            let tabelas = response.data.valores;

            this.dados = {
              id_produto: id,
              nome_produto: produto.nome_produto,
              ref_produto: produto.ref_produto,
              url_imagem: produto.url_imagem,
              id_categoria: produto.id_categoria,
              ingrediente: produto.ingrediente,
              gerar_pedido: produto.gerar_pedido,
              fg_ativo: produto.fg_ativo,
              adicionais: !adicionais ? [] : adicionais,
              produtos: itens == null ? [] : itens,
              tabelas: tabelas == null ? [] : tabelas,
            };

            this.tabelaCodigoSelect = this.dados.id_produto + String((this.dados.tabelas.length + 1));

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);

            if (res.status === 404) {
              this.$router.back();
            }
          });
      },

      addTabela() {
        if (this.tabelaValor === 0) {
          if (!confirm("Deseja inserir uma tabela com o preço '0,00' ?")) {
            return;
          }
        }

        let tabela = {
          'id_tabela': this.tabelaSelect.id_tabela,
          'ref_produto': this.tabelaCodigoSelect,
          'nome_tabela': this.tabelaSelect.nome_tabela,
          'valor': this.tabelaValor,
          'id_medida': this.id_medida,
          'outros': this.tabelaSelect.outros,
          'fg_ativo': 1
        };

        if (this.tabelaSelect.outros === '1') {
          tabela.nome_tabela = this.tabelaNomeSelect;
        }

        if (this.validarInsercaoTabela(this.dados.tabelas, tabela)) {
          openModalMsg("Atenção", "Esta tabela ou código ja está incluso!");
          return;
        }

        this.dados.tabelas.push(tabela);

        //clear
        this.tabelaSelect = this.tabelas[0];
        this.tabelaNomeSelect = '';
        this.tabelaUnidadeSelect = 1;
        this.tabelaCodigoSelect = this.dados.id_produto + String((this.dados.tabelas.length + 1));
        this.tabelaValor = 0;
        this.valorOriginal = 0;

      },

      validarInsercaoTabela(tabelas, tabela) {
        let invalido = false;
        tabelas.forEach(obj => {

          if ((obj.id_tabela === tabela.id_tabela && tabela.outros === '0') || (tabela.nome_tabela.trim() === obj.nome_tabela)) {
            invalido = true;
          }

          if (tabela.ref_produto === obj.ref_produto) {
            invalido = true;

          }
        });

        return invalido;
      },


      removeTabela(t) {
        let index = this.dados.tabelas.indexOf(t);
        if (index !== -1) this.dados.tabelas.splice(index, 1);
      },

      editarTabela(t) {
        //console.log(t);
        this.tabelaEdit = t.id_tabela_preco;
      },

      deletar() {
        if (confirm("Deseja realmente deletar este produto?")) {
          openLoading("Deletando!");
          this.$http.get(base_url + 'produto/remover/' + this.dados.id_produto + '/' + this.token)
            .then(() => {
              closeLoading();
              openModalMsg("Sucesso","Produto deletado com sucesso!");
              this.$router.push('/admin/produtos');

            }, res => {
              closeLoading();
              openModalMsg(res.data.result,res.data.msg);
            });
        }
      },

      calcularValor(value) {
        if (value && value > 0) {
          return value + (value * 0.15)
        }

        return 0;
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.getProduto(this.$route.params.id);
      }

      this.buscarCategorias();
      this.buscarTabelas();

      let valor = document.getElementById('valor');
      valor.addEventListener('blur', () => {
        this.tabelaValor = this.calcularValor(this.valorOriginal);
      });
    }
  }
</script>

<style scoped>
  .w3-centered tr td {
    padding: 13px;
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/produto/ProdutosCadastro.vue